import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* loadHomeOurPartner() {
  yield takeEvery(actionTypes.HOME_OUR_PARTNER, function* (action) {
    try {
      const response = yield API.businessCategory(action.data);
      if (response.data.success) {
        yield put(actions.homeLoadOurPartnerSuccess(response.data.data));
      } else {
        // console.log("Fail to load our partner. ", response.data.message);
      }
    } catch (error) {
      //   console.log("error, fail to load our partner ", error);
      yield put(actions.handleAPIError(error, "Fail to load our partner. \n"));
    }
  });
}

export function* loadMainCategoryList() {
  yield takeEvery(actionTypes.MALL_LOAD_MAIN_CATEGORY_LIST, function* (action) {
    try {
      const response = yield API.mallLoadMainCategoryList(
        action.dataType,
        action.data
      );
      if (response.data.success) {
        yield put(actions.mallLoadMainCategoryListSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to load mall category. \n" + response.data.message
        );
        yield put(actions.mallLoadMainCategoryListFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load mall category. \n")
      );
      yield put(actions.mallLoadMainCategoryListFail());
    }
  });
}

export function* loadCategoryList() {
  yield takeEvery(actionTypes.MALL_LOAD_CATEGORY_LIST, function* (action) {
    try {
      const response = yield API.mallLoadCategoryList(action.data);
      if (response.data.success) {
        yield put(actions.mallLoadCategoryListSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to load mall category. \n" + response.data.message
        );
        yield put(actions.mallLoadCategoryListFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load mall category. \n")
      );
      yield put(actions.mallLoadCategoryListFail());
    }
  });
}

export function* loadAllCategoryList() {
  yield takeEvery(actionTypes.MALL_LOAD_ALL_CATEGORIES, function* (action) {
    try {
      const response = yield API.mallLoadAllCategories(action.data);
      if (response.data.success) {
        yield put(actions.mallLoadAllCategoriesSuccess(response.data.data));
      } else {
        // console.log(
        //   "Warning: Fail to load all mall category. \n" + response.data.message
        // );
        yield put(actions.mallLoadProductListFail());
      }
    } catch (error) {
      //   console.log(
      //     "Fail to load all mall category. \n" + API.constructErrMsg(error)
      //   );
      yield put(actions.mallLoadProductListFail());
    }
  });
}

export default function* mallCategorySaga() {
  yield all([
    fork(loadHomeOurPartner),
    fork(loadMainCategoryList),
    fork(loadCategoryList),
    fork(loadAllCategoryList),
  ]);
}
